import { ContractDetail, ContractExpensesReport, ReactSimpleComponentProps } from '@/custom-types';
import { useMemo, useState } from 'react';
import { ContractDetailsContext, ContractDetailsContextProps } from './ContractDetailsContext';

export const ContractDetailsContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [contractState, setContractState] = useState<ContractDetail | undefined>(undefined)
  const [expensesReportState, setExpensesReportState] = useState<ContractExpensesReport | undefined>(undefined)

  const actions = useMemo<Omit<ContractDetailsContextProps, 'contract' | 'expensesReport'>>(() => ({
    setContract: (contract: ContractDetail | undefined) => setContractState(contract),
    setExpensesReport: (expensesReport: ContractExpensesReport | undefined) => setExpensesReportState(expensesReport),
  }), [])

  return (
    <ContractDetailsContext.Provider value={{ ...actions, contract: contractState, expensesReport: expensesReportState }} >
      {children}
    </ContractDetailsContext.Provider>
  )
}
